export enum DeviceLabelTriggerStatus {
  UNTRIGGERED = 'UNTRIGGERED',
  IN_PROGRESS = 'IN_PROGRESS',
  GRANTED = 'GRANTED',
  DENIED = 'DENIED',
}

export enum DeviceLabels {
  None = 1,
  Audio,
  Video,
  AudioAndVideo,
}

export enum MeetingMode {
  Spectator,
  Attendee,
}

export enum Layout {
  Gallery,
  Featured,
}
